import { observable, action, makeObservable } from 'mobx';

class MultimodalStore {
    constructor() {
        makeObservable(this);
    }

    @observable detailPanelOpen = false;
    @observable activeMessageId = null;
    @observable multimodalReference = null;

    @action
    setDetailPanelOpen = (flag) => {
        this.detailPanelOpen = !!flag;
    };

    @action
    setActiveMessageId = (id) => {
        this.activeMessageId = id;
    };

    @action
    setMultimodalReference = (data) => {
        this.multimodalReference = data;
    };

    @action
    clearMultimodalReference = () => {
        this.multimodalReference = null;
    };
}

export default new MultimodalStore();


